import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { fetchStatus } from '../status';
import { getReportOptions } from '../../api/network';

// Then, handle actions in your reducers:
const reportOptionsSlice = createSlice({
  name: 'reportOptions',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    reportOptionsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    reportOptionsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    reportOptionsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
  },
});

export const { reportOptionsFetchStart, reportOptionsFetchSuccess, reportOptionsFetchFail } = reportOptionsSlice.actions;

export const reportOptionsReducer = reportOptionsSlice.reducer;

export const fetchReportOptions = (data) => (dispatch) => {
  dispatch(reportOptionsFetchStart());

  getReportOptions(data)
    .then((payload) => {
      dispatch(reportOptionsFetchSuccess(payload.data));
    })
    .catch((error) => {
      dispatch(reportOptionsFetchFail(error));
    });
};
